/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Close_LabelInputs */

const en_subtitle_export_close_label = /** @type {(inputs: Subtitle_Export_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close dialog`)
};

const fr_subtitle_export_close_label = /** @type {(inputs: Subtitle_Export_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermer la boîte de dialogue`)
};

const de_subtitle_export_close_label = /** @type {(inputs: Subtitle_Export_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dialog schließen`)
};

const it_subtitle_export_close_label = /** @type {(inputs: Subtitle_Export_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiudi finestra di dialogo`)
};

const ru_subtitle_export_close_label = /** @type {(inputs: Subtitle_Export_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Закрыть диалог`)
};

const es_subtitle_export_close_label = /** @type {(inputs: Subtitle_Export_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar diálogo`)
};

const zh_cn2_subtitle_export_close_label = /** @type {(inputs: Subtitle_Export_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关闭对话框`)
};

const ja_subtitle_export_close_label = /** @type {(inputs: Subtitle_Export_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ダイアログを閉じる`)
};

const hi_subtitle_export_close_label = /** @type {(inputs: Subtitle_Export_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संवाद बंद करें`)
};

const pt_pt2_subtitle_export_close_label = /** @type {(inputs: Subtitle_Export_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fechar caixa de diálogo`)
};

/**
* | output |
* | --- |
* | "Close dialog" |
*
* @param {Subtitle_Export_Close_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_close_label = /** @type {((inputs?: Subtitle_Export_Close_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Close_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_close_label(inputs)
	if (locale === "de") return de_subtitle_export_close_label(inputs)
	if (locale === "it") return it_subtitle_export_close_label(inputs)
	if (locale === "ru") return ru_subtitle_export_close_label(inputs)
	if (locale === "es") return es_subtitle_export_close_label(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_close_label(inputs)
	if (locale === "ja") return ja_subtitle_export_close_label(inputs)
	if (locale === "hi") return hi_subtitle_export_close_label(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_close_label(inputs)
	return en_subtitle_export_close_label(inputs)
});